import type { Artifact } from './state';

/** Stable identity for an open artifact — same content ⇒ same key. */
export const artifactCanvasKey = (artifact: Artifact): string => {
  switch (artifact.type) {
    case 'session':
      // focusDocumentId / focusTab distinguish e.g. Context vs a specific doc.
      return `session:${artifact.sessionId}:${
        artifact.focusDocumentId ?? artifact.focusTab ?? ''
      }`;
    case 'note':
    case 'tasks':
    case 'codes':
      return `${artifact.type}:${artifact.sessionId}`;
    case 'patient':
      return `patient:${artifact.patientId}`;
    case 'document':
      return `document:${artifact.sessionId}:${artifact.documentId}`;
    case 'letter':
      return `letter:${artifact.sessionId}:${artifact.letterId}`;
    case 'template-builder':
      return `template-builder:${artifact.templateId}`;
    case 'form-template':
      return `form-template:${artifact.templateId}`;
    case 'library-document':
      return `library-document:${artifact.documentId}`;
    case 'presentation':
      return `presentation:${artifact.presentationId}`;
    case 'memory':
      return `memory:${artifact.memoryId}`;
    case 'workflow':
      return `workflow:${artifact.workflowId}`;
    case 'document-export':
      return `${artifact.type}:${artifact.url}`;
    case 'run-attachment':
      return `run-attachment:${artifact.agentRunId}:${artifact.attachmentId}`;
    case 'created-objects':
      return `created-objects:${artifact.projectId}`;
    case 'session-list':
      return `session-list:${artifact.startDate ?? ''}:${artifact.endDate ?? ''}:${artifact.sessionIds.join(',')}`;
    case 'calendar':
      return `calendar:${artifact.provider ?? ''}:${artifact.start ?? ''}:${artifact.end ?? ''}:${artifact.events.map((e) => e.id).join(',')}`;
    case 'mail':
      return `mail:${artifact.provider ?? ''}:${artifact.query ?? ''}:${artifact.messages.map((m) => m.id).join(',')}`;
    case 'files':
      return `files:${artifact.provider ?? ''}:${artifact.query ?? ''}:${artifact.files.map((f) => f.id).join(',')}`;
    case 'insurance':
      return `insurance:${artifact.variant}:${artifact.provider ?? ''}:${artifact.query ?? ''}:${artifact.patients.map((p) => p.id).join(',')}`;
    case 'note-push-verification':
      return `note-push-verification:${artifact.templateId}::${artifact.appName}`;
    case 'library':
      return 'library';
    default: {
      const _exhaustive: never = artifact;
      return _exhaustive;
    }
  }
};
